<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('Create', 'Provider')">
        <b-button v-b-modal.modal-newProvider variant="primary">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span>Add New</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Providers">
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="filter"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-table
            striped
            :items="items"
            :fields="fields"
            :filter="filter"
            :per-page="perPage"
            :current-page="currentPage"
            caption-top
            :responsive="true"
          >
            <template
              v-slot:cell(actions)="data"
              v-if="$can('Update', 'Provider') || $can('Delete', 'Provider')"
            >
              <b-row>
                <b-dropdown
                  variant="link"
                  no-caret
                  :right="$store.state.appConfig.isRTL"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item
                    v-if="$can('Update', 'Provider')"
                    href="#"
                    variant="success"
                    @click="editProviderModal(data.item.id)"
                  >
                    <feather-icon class="yellow-icon" icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="$can('Delete', 'Provider')"
                    href="#"
                    variant="danger"
                    @click="
                      deleteProvider(data.item.id, data.item.providerName)
                    "
                  >
                    <feather-icon class="blue-icon" icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item>
                </b-dropdown>
              </b-row>
            </template>
          </b-table>
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to &nbsp; </span>
              <b-form-select
                id="per-page-select"
                v-model="perPage"
                :options="[5, 10, 15, 20, { value: 100, text: 'Show all' }]"
                size="sm"
              ></b-form-select>
              <span class="text-nowrap">
                &nbsp; of {{ items.length }} entries
              </span>
            </div>
            <div>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              />
            </div>
          </div>
        </b-col>
      </b-row>

      <b-col>
        <b-modal
          id="modal-newProvider"
          ref="modal"
          hide-footer
          title="Add New Provider"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form">
              <b-row>
                <b-col md="6">
                  <b-form-group label="Provider Name" label-for="providerName">
                    <validation-provider
                      #default="{ errors }"
                      name="providerName"
                      rules="required"
                    >
                      <b-form-input
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        v-on:keypress="isLetter($event)"
                        id="providerName-input"
                        v-model="newCompany.providerName"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Description" label-for="description">
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      rules="required"
                    >
                      <b-form-input
                        v-on:keypress="isLetter($event)"
                        v-on:paste="
                          (e) => {
                            e.preventDefault();
                            return false;
                          }
                        "
                        id="code-input"
                        v-model="newCompany.description"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Default Payment Option"
                    label-for="defaul-tPayment-Option"
                  >
                    <b-form-select
                      v-model="newCompany.defaultPaymentOption"
                      :options="paymentOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Partner Type" label-for="partnerType">
                    <validation-provider
                      #default="{ errors }"
                      name="PartnerType"
                      rules="required"
                    >
                      <b-form-select
                        v-model="newCompany.partnerType"
                        :options="partnerTypeOptions"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Country" label-for="country">
                    <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                    >
                      <b-form-select
                        id="country-input"
                        v-model="newCompany.country"
                        :options="countryOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <b-button
                    variant="primary"
                    type="submit"
                    @click.prevent="submitNewProvider"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>
      <b-col>
        <b-modal
          id="modal-editCompany"
          ref="modal"
          hide-footer
          title="Edit Provider"
          size="lg"
        >
          <validation-observer ref="simpleRules">
            <form ref="form" @submit.stop.prevent="submitEditProvider">
              <b-row>
                <b-form-input v-model="editCompany.id" hidden />
                <b-col md="6">
                  <b-form-group label="Provider Name" label-for="providerName">
                    <validation-provider
                      #default="{ errors }"
                      name="providerName"
                      rules="required"
                    >
                      <b-form-input
                        id="providerName-input"
                        v-model="editCompany.providerName"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Description" label-for="description">
                    <validation-provider
                      #default="{ errors }"
                      name="description"
                      rules="required"
                    >
                      <b-form-input
                        id="code-input"
                        v-model="editCompany.description"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    label="Default Payment Option"
                    label-for="defaul-tPayment-Option"
                  >
                    <b-form-select
                      v-model="editCompany.defaultPaymentOption"
                      :options="paymentOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="6">
                  <b-form-group label="Partner Type" label-for="partnerType">
                    <b-form-select
                      v-model="editCompany.partnerType"
                      :options="partnerTypeOptions"
                    />
                  </b-form-group>
                </b-col>
                <b-col md="6">
                  <b-form-group label="Country" label-for="country">
                    <validation-provider
                      #default="{ errors }"
                      name="country"
                      rules="required"
                    >
                      <b-form-select
                        id="country-input"
                        v-model="editCompany.country"
                        :options="countryOptions"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="6">
                  <b-button
                    variant="primary"
                    type="submit"
                    @click.prevent="submitEditProvider"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </form>
          </validation-observer>
        </b-modal>
      </b-col>

      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
  BTable,
  BPagination,
  BFormGroup,
  BCard,
  BOverlay,
  BDropdownItem,
  BDropdown,
  BButton,
} from "bootstrap-vue";
import { required } from "@validations";

import { ValidationProvider, ValidationObserver } from "vee-validate";
import axios from "@axios";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    BTable,
    BPagination,
    BFormGroup,
    BCard,
    BOverlay,
    BDropdownItem,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BButton,
  },
  data() {
    return {
      required,
      isLoading: false,
      props: ["items"],
      fields: [
        "providerName",
        "defaultPaymentOptionDescription",
        "country",
        "description",
        "Actions",
      ],
      items: [],
      filter: "",
      perPage: 10,
      currentPage: 1,
      newCompany: {
        providerName: "",
        defaultPaymentOption: 0,
        country: "",
        partnerType: 1,
        description: "",
      },
      editCompany: {
        id: 0,
        providerName: "",
        defaultPaymentOption: 0,
        country: "",
        partnerType: 1,
        description: "",
      },
      paymentOptions: [{ value: 0, text: "Default" }],
      countryOptions: [{ value: null, text: "--select a Country--" }],
      partnerTypeOptions: [
        { value: 1, text: "Bank" },
        { value: 2, text: "Merchant" },
        { value: 3, text: "PSP" },
      ],
    };
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    try {
      this.fetchData();
      this.fetchallPaymentOptions();
    } catch (error) {
      console.error(error);
    }
  },
  methods: {
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[a-zA-Z\s]*$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    deleteProvider(id, name) {
      this.$bvModal
        .msgBoxConfirm(`Are you sure to Delete  ${name}`, {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          headerBgVariant: "warning",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          this.boolValue = value;
          if (value) {
            this.isLoading = true;
            axios
              .delete(`/Provider/api/V1.0/Provider/Delete?id=${id}`)
              .then((res) => {
                this.isLoading = false;
                this.$bvModal
                  .msgBoxOk(`${res.message}`, {
                    title: "Success",
                    size: "sm",
                    buttonSize: "sm",
                    okVariant: "success",
                    headerClass: "p-2 border-bottom-0",
                    footerClass: "p-2 border-top-0",
                    centered: true,
                  })
                  .then((result) => {
                    if (result) {
                      this.fetchData();
                    }
                  });
              })
              .catch((res) => {
                this.isLoading = false;

                this.$bvModal.msgBoxOk(`${res.data.message}`, {
                  title: "error",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                });
              });
          }
        });
    },
    editProviderModal(id) {
      const item = this.items.filter((i) => i.id === id);

      // eslint-disable-next-line prefer-destructuring
      this.editCompany = item[0];

      this.$bvModal.show("modal-editCompany");
    },

    submitNewProvider() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$bvModal.hide("modal-newProvider");
          this.isLoading = true;
          this.$store.dispatch("config/getActionPrivilege", "Provider-Create");
          axios
            .post("/Provider/api/V1.0/Provider/Create", this.newCompany)
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.newCompany.name = "";
                    this.newCompany.address = "";
                    this.newCompany.email = "";
                    this.newCompany.poBox = "";

                    this.fetchData();
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    submitEditProvider() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$bvModal.hide("modal-editCompany");
          this.isLoading = true;
          axios
            .put("/Provider/api/V1.0/Provider/Update", this.editCompany)
            .then((res) => {
              this.isLoading = false;
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.fetchData();
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Provider-View");
      axios
        .get("/Provider/api/V1.0/Provider/GetAll")
        .then((res) => {
          this.items = res.providers;
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.isLoading = false;
        });
      axios
        .get("/Country/api/V1.0/Country/GetAll")
        .then((res) => {
          res.countries.forEach((item) => {
            this.countryOptions.push({
              value: item.countryName,
              text: item.countryName,
            });
          });
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    fetchallPaymentOptions() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "Order-View");
      axios
        .get(
          "/PaymentOptions/api/V1.0/PaymentOptions/ViewMerchantPaymentOptions"
        )
        .then((res) => {
          res.paymentOptions.forEach((item) => {
            this.paymentOptions.push({
              value: item.paymentOption,
              text: item.name,
            });
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
